export default __webpack_public_path__ + "static/media/CaptainAmericaShield1.1db7132a.jpeg";